import React from "react";
import styles from "./FilterPanel.module.css";
import { Box, Button, Typography } from "@mui/material";
import GenericFilterItem from "../../GenericFilterItem";
import { Filter, FilterType } from "../../../context/ConfigContext/types";
import CheckedToggle from "./CheckedToggle";
import CloseIcon from "@mui/icons-material/Close";
import { Document } from "../../../types";

export interface GenericFilterItemProps {
	title?: string;
	filter?: Filter;
	children?: React.ReactNode;
	documents?: Document[];
	onUnselectDocumentClick?: (documentId: number) => void;
}

const FilterPanelItem: React.FunctionComponent<GenericFilterItemProps> = ({
	title = "",
	filter,
	children,
	documents,
	onUnselectDocumentClick,
}) => {
	return (
		<>
			{title && (
				<Typography
					className={styles.title}
					variant="body2"
					align="left"
					color="white"
				>
					{title}
				</Typography>
			)}
			<Box className={styles.field}>
				{filter && (
					<>
						{filter.type === FilterType.CHECKED ? (
							<Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
								<Typography color="white" variant="body2">
									Checked
								</Typography>
								<CheckedToggle filter={filter} />
							</Box>
						) : (
							<Box className={styles.genericFilterItemWrapper}>
								<GenericFilterItem size={"small"} filter={filter} />
							</Box>
						)}
					</>
				)}
				{children}
				{documents &&
					documents.map((document) => (
						<SelectedDocument
							title={document.title}
							onUnselectClick={() => onUnselectDocumentClick(document.id)}
							key={document.id}
						/>
					))}
			</Box>
		</>
	);
};

const SelectedDocument: React.FunctionComponent<{
	title: string;
	onUnselectClick: () => void;
}> = ({ title, onUnselectClick }) => {
	return (
		<Box
			sx={{
				height: "40px",
				display: "flex",
				backgroundColor: "#d6d6de",
				marginTop: "10px",
				alignItems: "center",
				width: "fit-content",
				paddingLeft: "15px",
				borderRadius: "4px",
			}}
		>
			<Typography
				variant="body1"
				style={{
					maxWidth: "320px",
					overflow: "hidden",
					whiteSpace: "nowrap",
					textOverflow: "ellipsis",
					marginRight: "2px",
					flexShrink: 0,
					flexGrow: 1,
				}}
			>
				{title}
			</Typography>
			<Button onClick={() => onUnselectClick()}>
				<CloseIcon />
			</Button>
		</Box>
	);
};

export default FilterPanelItem;
